import { type TouchEvent, useState } from 'react';

/** A sheet that has been dragged this far down closes on release. */
const DISMISS_THRESHOLD_PX = 72;

/**
 * Swipe-down-to-close for bottom sheets. Twenty ships zero gestures; on a phone
 * a sheet that can only be closed by aiming at a 40px X is worse than the
 * gesture everyone already expects.
 *
 * The handlers are attached to the grabber area only, never to the scrollable
 * body, so a swipe inside the content still scrolls.
 */
export function useSwipeDismiss(onDismiss: () => void) {
  const [start, setStart] = useState<number | null>(null);
  const [offset, setOffset] = useState(0);

  const reset = () => {
    setStart(null);
    setOffset(0);
  };

  return {
    /** Pixels the sheet is currently dragged down by (never negative). */
    offset,
    handlers: {
      onTouchStart: (event: TouchEvent) => {
        const touch = event.touches[0];
        if (touch !== undefined) {
          setStart(touch.clientY);
        }
      },
      onTouchMove: (event: TouchEvent) => {
        const touch = event.touches[0];
        if (start === null || touch === undefined) {
          return;
        }
        setOffset(Math.max(0, touch.clientY - start));
      },
      onTouchEnd: () => {
        if (offset > DISMISS_THRESHOLD_PX) {
          onDismiss();
        }
        reset();
      },
      onTouchCancel: reset,
    },
  };
}
